module.exports = __webpack_public_path__ + "static/media/profileInfo_blue.5bbb2570.svg";